export default __webpack_public_path__ + "static/media/join-avatar-3.7a870572.png";